import { Language } from '../../types/language'

export type StartCopy = {
  heading: string
  subheading: string
  intro: string
  facts: string[]
  counter: string
  imageAlt: string
  portraitAlt: string
  portraitToggleLabel: string
  price: string
  priceNormal: string
  priceFor: string
  priceTerms: string
  cta: string
  includesHeading: string
  includes: string[]
  askHeading: string
  askIntro: string
  asks: string[]
  askOptional: string
  forWhoHeading: string
  forWho: string
  goodToKnowHeading: string
  goodToKnow: string[]
  closingHeading: string
  closingText: string
}

export const startCopy: Record<Language, StartCopy> = {
  nl: {
    heading: 'Zit je al een tijdje niet lekker op je plek?',
    subheading:
      'Twijfel je over je volgende stap? Samen zoeken we uit hoe je met vertrouwen kiest voor jouw volgende avontuur.',
    intro:
      'Zes gesprekken, online of wandelend in de natuur, in de buurt van Utrecht. Ik bied acht plekken aan tegen een sterk verlaagd tarief, omdat ik ervaring en referenties opbouw voor mijn ICF-accreditatie.',
    facts: [
      '6 gesprekken van een uur',
      'Online of in de natuur bij Utrecht',
      '€295 in plaats van €750',
    ],
    counter: 'Nog 8 van 8 plekken beschikbaar',
    imageAlt: 'Mark lachend in gesprek aan een picknicktafel in het park',
    portraitAlt: 'Portret van Mark Vermeulen',
    portraitToggleLabel: 'Toon het portret van Mark groter',
    price: '€295 inclusief btw',
    priceNormal: 'normaal €750',
    priceFor: 'voor 6 sessies',
    priceTerms:
      'In één keer, of in twee termijnen: €150 bij de start en €145 na sessie drie.',
    cta: 'Start met een Connection Talk',
    includesHeading: 'Dit is wat je krijgt',
    includes: [
      'Een gratis Connection Talk van 30 minuten, telefonisch of wandelend',
      'Zes sessies van een uur, ongeveer elke twee weken',
      'Online of wandelend in de natuur, in de buurt van Utrecht',
      'Tussendoor bereikbaar via mail of app',
      'Een korte check-in halverwege het traject',
      'Een Clarity Roadmap met concrete vervolgstappen',
    ],
    askHeading: 'Wat ik van je vraag',
    askIntro:
      'Omdat je tegen een sterk verlaagd tarief deelneemt, vraag ik drie dingen terug:',
    asks: [
      'Een eerlijke, schriftelijke review na afloop',
      'Korte feedback halverwege: wat werkt en wat kan beter',
      'Eén introductie naar iemand voor wie dit ook waardevol kan zijn',
    ],
    askOptional:
      'Optioneel: toestemming om één sessie als audio op te nemen voor mijn ICF-opleiding. Die opname wordt alleen gebruikt voor beoordeling en daarna verwijderd. Dit is volledig vrijwillig en heeft geen invloed op je traject.',
    forWhoHeading: 'Voor wie',
    forWho:
      'Je bent een paar jaar aan het werk, op papier klopt alles, maar je vraagt je af of dit het nou is. Je wilt uitzoeken wat jij echt wilt, en de volgende stap met vertrouwen zetten.',
    goodToKnowHeading: 'Goed om te weten',
    goodToKnow: [
      'Coaching is geen therapie. Merken we in de kennismaking dat je beter geholpen bent bij een psycholoog, dan zeg ik dat eerlijk en help ik je de goede kant op.',
      'Sessies zijn ook in het Engels mogelijk.',
      'Dit aanbod geldt tot alle acht plekken bezet zijn.',
    ],
    closingHeading: 'Zullen we kennismaken?',
    closingText:
      'Een gesprek van 30 minuten, gratis en vrijblijvend. Daarna beslis je pas.',
  },
  en: {
    heading: 'Been feeling out of place for a while?',
    subheading:
      'Unsure about your next step? Together we work out how to choose your next adventure with confidence.',
    intro:
      'Six conversations, online or walking in nature near Utrecht. I offer eight places at a strongly reduced rate, because I am building experience and references for my ICF accreditation.',
    facts: [
      '6 one-hour conversations',
      'Online or in nature near Utrecht',
      '€295 instead of €750',
    ],
    counter: '8 of 8 places still available',
    imageAlt: 'Mark laughing in conversation at a picnic table in the park',
    portraitAlt: 'Portrait of Mark Vermeulen',
    portraitToggleLabel: 'Show Mark’s portrait larger',
    price: '€295 including VAT',
    priceNormal: 'normally €750',
    priceFor: 'for 6 sessions',
    priceTerms:
      'In one payment, or in two instalments: €150 at the start and €145 after session three.',
    cta: 'Start with a Connection Talk',
    includesHeading: 'This is what you get',
    includes: [
      'A free 30-minute Connection Talk, by phone or walking',
      'Six one-hour sessions, roughly every two weeks',
      'Online or walking in nature near Utrecht',
      'Reachable in between by email or app',
      'A short check-in halfway through the journey',
      'A Clarity Roadmap with concrete next steps',
    ],
    askHeading: 'What I ask of you',
    askIntro:
      'Because you join at a strongly reduced rate, I ask three things in return:',
    asks: [
      'An honest, written review afterwards',
      'Short feedback halfway: what works and what could be better',
      'One introduction to someone who might also find this valuable',
    ],
    askOptional:
      'Optional: permission to record one session as audio for my ICF training. That recording is only used for assessment and deleted afterwards. This is entirely voluntary and has no influence on your journey.',
    forWhoHeading: 'Who this is for',
    forWho:
      'You have been working for a few years, on paper everything adds up, but you wonder whether this is really it. You want to find out what you truly want, and take the next step with confidence.',
    goodToKnowHeading: 'Good to know',
    goodToKnow: [
      'Coaching is not therapy. If we notice during the intro that a psychologist would serve you better, I will say so honestly and help you find the right direction.',
      'Sessions are also available in English.',
      'This offer runs until all eight places are taken.',
    ],
    closingHeading: 'Shall we meet?',
    closingText:
      'A 30-minute conversation, free and without obligation. You decide afterwards.',
  },
}
